import React from 'react'
import { Div, Flex, PricingTile } from '@sendoutcards/quantum-design-ui'
import styles from './plans.module.scss'
import { PlansDescription } from 'src/marketing/plans/types'

type PlanProps = {
  plansDescriptions: PlansDescription[]
  pricingTitle?: string
  pricingSubtitle?: string
  onSelect: (planTitle: string) => void
}

const Plans: React.FC<PlanProps> = props => {
  const { plansDescriptions, pricingTitle, pricingSubtitle, onSelect } = props
  const defaultTitle =
    'Reach out in kindness with Heartfelt Prompting Card Subscriptions'
  const defaultSubtitle =
    'We have the perfect way to act on promptings and reach out in kindness, no matter how you choose to use SendOutCards. Start making a difference by selecting the plan that will work best for you. If you change your mind later, no worries — you can always switch plans or cancel.'

  return (
    <Div
      className={styles.plansContainer}
      style={{
        marginTop: 50,
      }}
    >
      <Div className={styles.planCopy}>
        <h4>{pricingTitle ?? defaultTitle}</h4>
        <p>{pricingSubtitle ?? defaultSubtitle}</p>
      </Div>
      <Flex
        outset="x2"
        flexWrap="wrap"
        justifyContent="space-evenly"
        alignItems="flex-start"
      >
        {plansDescriptions
          // Filter out basic plan
          .filter(plansDescription => plansDescription.id !== '1')
          .map(plan => {
            const description = plan.description
            const planFeatures = description?.details?.map(detail => {
              if (detail.innerDetails) {
                return {
                  feature: detail.detail,
                  subFeatures: detail.innerDetails.map(d => d.detail),
                  isNotIncluded: false, // todo fix this
                }
              }
              return detail.detail
            })
            if (planFeatures && description) {
              return (
                <Div className={styles.pricingTable}>
                  <Div
                    outset={{ horizontal: 'x1' }}
                    height="auto"
                    maxWidth="456px"
                  >
                    <PricingTile
                      featuredItemStyles={{
                        backgroundColor: 'accent',
                        textColor: 'gray',
                        accentColor: 'secondaryBrand',
                      }}
                      accentColor="secondaryBrand"
                      description={description.description}
                      title={description.plan}
                      features={planFeatures}
                      isSelected={description.isFeatured}
                      billingInterval={'Monthly'}
                      isFeatured={description.isFeatured ?? false}
                      primaryAction={{
                        text: 'Purchase Now',
                        onClick: () => onSelect(plan.id),
                      }}
                    />
                  </Div>
                </Div>
              )
            }
            return <> </> // todo don't return a fragment
          })}
      </Flex>
    </Div>
  )
}

export default Plans
